import React from "react";
import {Box} from "@mui/system";
import remarkableLogo from 'components/images/logos/remarkable_dark_logo.svg'

export default function RemarkableWordmark({}) {
    return(
        <Box sx={{width: '165px', cursor: 'pointer', zIndex: '10', position: 'relative'}}>
            <a href={'/'}><img src={remarkableLogo} className='full-width' alt={`Remarkable wordmark`}/></a>
        </Box>
    )
}